import React, { memo } from 'react';
import { URL } from 'constants/urlMaps';
import { formatDateToMonth } from 'utils/date';
import { FontSize, Transitions } from 'theme';
import { colors } from 'constants/colors';
import { STATES } from 'Containers/Profile/Orders/OrderStatusLabel';
import styled from 'styled-components';
import Box from 'Components/Grid/Box';
import Text from 'Components/Typography/Text';
import { IOrdersMainInfo } from 'Modules/OrdersHistory/types';
import { equals } from 'ramda';
import LinkWrapper from 'Components/Link/LinkWrapper';
import amplitude from 'utils/amplitude';
import { EnumEvents, WLabel } from 'constants/enums';
import { currentWLabel } from 'utils/wLabel';

export const UPCOMING_ORDERS_TEST_ID = 'UPCOMING_ORDERS_TEST_ID';
export const UPCOMING_ORDER_LINK_TEST_ID = 'UPCOMING_ORDER_LINK_TEST_ID';
export const UPCOMING_ORDERS_FETCH_INTERVAL = 300000;

const OrderWrapper = styled(Box).attrs({ px: 4, py: 4 })`
  background-color: ${colors.paleGreyThree};
  transition: ${Transitions.bg};
  border-bottom: 1px solid ${colors.white};

  &:hover {
    background-color: ${colors.paleGrey};
  }
`;

const ShopImageWrapper = styled(Box)<{ image: string }>`
  background-image: url(${({ image }) => image});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: left center;
  width: 100%;
  height: 28px;
  margin-left: -5px;
`;

const OrderDate = styled(Text)`
  line-height: 17px;
`;

interface IProfileDropdown {
  orders: IOrdersMainInfo[];
}

const UpcomingOrders: React.FC<IProfileDropdown> = ({ orders }) => {
  const handleOrderLinkClick = () => amplitude.logEvent(EnumEvents.CLICK_ORDER_PROFILE_DROPDOWN);
  return (
    <Box data-testid={UPCOMING_ORDERS_TEST_ID}>
      {orders.map(order => (
        <LinkWrapper
          onClick={handleOrderLinkClick}
          key={order.id}
          to={`${URL.profile_orders}/${order.id}`}
          data-testid={UPCOMING_ORDER_LINK_TEST_ID}
        >
          <OrderWrapper>
            {currentWLabel === WLabel.Default && <ShopImageWrapper image={order.shop_logo} />}
            <Box>
              <OrderDate>Заказ на {formatDateToMonth(order.delivery_date)}</OrderDate>
            </Box>
            <Text size={FontSize.xs} color={colors.warmGrey}>
              {STATES[order.status].label}
            </Text>
          </OrderWrapper>
        </LinkWrapper>
      ))}
    </Box>
  );
};

export default memo(UpcomingOrders, equals);
